// extracted by mini-css-extract-plugin
export var regionListWrap = "regionList-module--regionListWrap--vrh1G";
export var listFrame = "regionList-module--listFrame--WjvZr";
export var regionListScroll = "regionList-module--regionListScroll--FZA4u";
export var regionListInner = "regionList-module--regionListInner--eB+fa";
export var list = "regionList-module--list--VMCDX";
export var arrow = "regionList-module--arrow--1kLvK";
export var slideUp = "regionList-module--slideUp--lIRnU";
export var slideUpLarge = "regionList-module--slideUpLarge--mQg1Q";